export default __webpack_public_path__ + "static/media/rect.45018b5c.svg";